import _ from 'lodash';

import { ID_DEFINITION, ID_GRAPH_AXIS } from '../../constants/idDefinition';
import { TABLE_DATA_SOURCE, UNITS_SIGN, CHART_TYPE, SIMULATION_TYPE } from '../../constants/definitionConstants';
import { SINGLE_MOSFET } from '../../constants/prtParametersNames';
import { getDomain } from '../../../utils/config';

export class single_mosfet_thermal {
	constructor(opn, wpn) {
		this.opn = opn;
		this.domain = getDomain();
		this.wpn = wpn;
		this.PIN_MAP = require(`../../images/${this.opn}_PM.svg`);
		this.netlistPath = `resources/${this.wpn}/${this.opn}/netlists/${this.opn}_DC.txt`;
		this.SCHEMATIC = this.loadSchematicImage();
		this.netlistZthSim = `resources/${this.wpn}/${this.opn}/netlists/${this.opn}_ZTH.txt`;
		this.SCHEMATICZthSim = require(`../../images/${this.opn}_ZTH_SCH.svg`);
		this.netlistTempSweep = `resources/${this.wpn}/${this.opn}/netlists/${this.opn}_TEMP_DC.txt`;
		this.SCHEMATICTempSweep = require(`../../images/${this.opn}_TEMP_SCH.svg`);
		this.DC_CHART_COLUMN_MAPPING = {
			V_DS: 0,
			V_GS: 1,
			TEMP: 2,
			I_DRAIN: 3,
			R_DSON: 4,
			T_J: 5
		};
		this.TEMP_SWEEP_CHART_COLUMN_MAPPING = {
			V_GS: 0,
			TEMP: 1,
			V_DS: 2,
			I_DRAIN: 3,
			R_DSON: 4,
			T_J: 5
		};
		this.ZTH_CHART_COLUMN_MAPPING = {
			TIME: 0,
			TEMP: 1,
			T_J: 2,
			IPULSE: 3
		};
	}

	loadSchematicImage() {
		try {
			return require(`../../images/${this.opn}_SCH.svg`);
		} catch (error) {
			console.error(`Schematic image for ${this.opn} not found.`);
		}
	}

	gainDefinition(customizations = {}) {
		const defaultDefinition = {
			/**
			 * Name of Page
			 */
			mainHeading: this.opn.toUpperCase(),
			wpn: this.wpn.toUpperCase(),

			/**
			 * is used to get description, table, primary and secondary links base parameter to pull data from WD+ database (value is OPN)
			 */
			defaultMappingName: this.opn.toUpperCase(),
			primaryLinks: [
				{
					/**
					 * used to identify element and map data from WD+
					 */
					id: ID_DEFINITION.PRODUCT_PAGE,
					description: 'Part Name',
					heading: this.wpn.toUpperCase()
				},
				{
					id: ID_DEFINITION.DATASHEET,
					description: 'Datasheet',
					heading: 'Open Datasheet'
				}
			],
			secondaryLinks: [
				{
					id: ID_DEFINITION.SIMILAR_PRODUCTS,
					heading: 'Find similar products'
				},
				{
					id: ID_DEFINITION.EVALUATION_BOARD,
					heading: 'Evaluation board'
				}
			],
			pinMap: {
				heading: 'Pin Map',
				imagePath: this.PIN_MAP
			},
			package: {
				heading: 'Package 3D',
				imagePath: this.PACKAGE_IMAGE,
				links: [
					{
						id: ID_DEFINITION.CASE_OUTLINE,
						heading: 'Case outline drawing'
					},
					{
						id: ID_DEFINITION.CASE_CAD,
						heading: 'CAD Model'
					}
				]
			},
			/**
			 * It is empty but it needs to be present, if not data wont load and description section will be empty.
			 */
			longDescription: {},

			table: {
				heading: 'Electrical Parameters',
				prtDataTaxonomy: SINGLE_MOSFET.TAXONOMY_ID,
				/**
				 * Format for table parameter data from PRT
				 * {
				 * 		dataSource: TABLE_DATA_SOURCE.PRT,
				 *		mappingName: POWER_SUPPLY.V_BR_DSS
				 * 	}
				 */
				data: [
					{
						dataSource: TABLE_DATA_SOURCE.PRT,
						mappingName: SINGLE_MOSFET.CHANNEL_POLARITY
					},
					{
						dataSource: TABLE_DATA_SOURCE.PRT,
						mappingName: SINGLE_MOSFET.CONFIGURATION
					},
					{
						dataSource: TABLE_DATA_SOURCE.PRT,
						mappingName: SINGLE_MOSFET.V_BR_DSS_MIN
					},
					{
						dataSource: TABLE_DATA_SOURCE.PRT,
						mappingName: SINGLE_MOSFET.I_D_MAX
					},
					{
						dataSource: TABLE_DATA_SOURCE.PRT,
						mappingName: SINGLE_MOSFET.V_GS_TH_MAX
					},
					{
						dataSource: TABLE_DATA_SOURCE.PRT,
						mappingName: SINGLE_MOSFET.V_GS_MAX
					},
					{
						dataSource: TABLE_DATA_SOURCE.PRT,
						mappingName: SINGLE_MOSFET.Q_GD_TYP_V_GS_4_5V
					},
					{
						dataSource: TABLE_DATA_SOURCE.PRT,
						mappingName: SINGLE_MOSFET.R_DS_ON_MAX_VGS_10V
					},
					{
						dataSource: TABLE_DATA_SOURCE.PRT,
						mappingName: SINGLE_MOSFET.R_DS_ON_MAX_VGS_4_5V
					},
					{
						dataSource: TABLE_DATA_SOURCE.PRT,
						mappingName: SINGLE_MOSFET.R_DS_ON_VGS_2_5V
					},
					{
						dataSource: TABLE_DATA_SOURCE.PRT,
						mappingName: SINGLE_MOSFET.Q_G_TYP_VGS_10V
					},
					{
						dataSource: TABLE_DATA_SOURCE.PRT,
						mappingName: SINGLE_MOSFET.Q_G_TYP_VGS_4_5V
					},
					{
						dataSource: TABLE_DATA_SOURCE.PRT,
						mappingName: SINGLE_MOSFET.P_D_MAX
					},
					{
						dataSource: TABLE_DATA_SOURCE.PRT,
						mappingName: SINGLE_MOSFET.Q_RR_TYP
					},
					{
						dataSource: TABLE_DATA_SOURCE.PRT,
						mappingName: SINGLE_MOSFET.C_ISS_TYP
					},
					{
						dataSource: TABLE_DATA_SOURCE.PRT,
						mappingName: SINGLE_MOSFET.C_OSS_TYP
					},
					{
						dataSource: TABLE_DATA_SOURCE.PRT,
						mappingName: SINGLE_MOSFET.C_RSS_TYP
					},
					{
						dataSource: TABLE_DATA_SOURCE.PRT,
						mappingName: SINGLE_MOSFET.T_J
					},
					{
						dataSource: TABLE_DATA_SOURCE.PRT,
						mappingName: SINGLE_MOSFET.TECHNOLOGY
					}
				]
			},
			simulations: [
				{
					heading: 'DC Analysis Simulation',
					showRawData: false,
					inputHeading: 'Input parameters',
					showInputParams: false,
					simulationLinks: [
						{
							heading: 'SPICE model link',
							/**
							 * link for simulation download
							 */
							link: this.modelLink
						}
					],
					/**
					 * defining netlist download icon and also path to netlist in spice project for whole simulation run
					 */
					netlist: {
						heading: 'Netlist',
						/**
						 * path to netlist in spice-simulator project (netlist used for this simulation)
						 */
						netlistPath: this.netlistPath,
						displayNetlist: false
					},
					schematic: {
						heading: 'Netlist schematic',
						schematicPath: this.SCHEMATIC
					},
					charts: [
						{
							/**
							 * ---------------------------------------------------I_DRAIN vs V_DS ---------------------------------------------------
							 */
							id: 'IdVsVds',
							mainHeading:
								'I[baseline-shift: sub; font-size: 11px;]DRAIN[/] = f (V[baseline-shift: sub; font-size: 11px;]DS[/], V[baseline-shift: sub; font-size: 11px;]GS[/])',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.DC,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'V[baseline-shift: sub; font-size: 11px;]DS[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: this.DC_CHART_COLUMN_MAPPING.V_DS
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'I[baseline-shift: sub; font-size: 11px;]DRAIN[/]',
									unit: UNITS_SIGN.AMPER,
									columnNumber: this.DC_CHART_COLUMN_MAPPING.I_DRAIN,
									clampMaxRating: {
										mappingName: SINGLE_MOSFET.I_D_MAX
									}
								}
							],
							series: {
								/**
								 * Here graph parametrization is defined
								 */
								heading: 'V[baseline-shift: sub;font-size: 11px;]GS[/]',
								unit: UNITS_SIGN.VOLT,
								columnNumber: this.DC_CHART_COLUMN_MAPPING.V_GS
							}
						},
						{
							/**
							 * ---------------------------------------------------I_DRAIN vs V_GS ---------------------------------------------------
							 */
							id: 'IdVsVgs',
							mainHeading:
								'I[baseline-shift: sub; font-size: 11px;]DRAIN[/] = f (V[baseline-shift: sub; font-size: 11px;]GS[/], V[baseline-shift: sub; font-size: 11px;]DS[/])',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.DC,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'V[baseline-shift: sub; font-size: 11px;]GS[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: this.DC_CHART_COLUMN_MAPPING.V_GS
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'I[baseline-shift: sub; font-size: 11px;]DRAIN[/]',
									unit: UNITS_SIGN.AMPER,
									columnNumber: this.DC_CHART_COLUMN_MAPPING.I_DRAIN,
									clampMaxRating: {
										mappingName: SINGLE_MOSFET.I_D_MAX
									}
								}
							],
							series: {
								/**
								 * Here graph parametrization is defined
								 */
								heading: 'V[baseline-shift: sub;font-size: 11px;]DS[/]',
								unit: UNITS_SIGN.VOLT,
								columnNumber: this.DC_CHART_COLUMN_MAPPING.V_DS
							}
						},
						{
							/**
							 * ---------------------------------------------------R_dsON vs I_D ---------------------------------------------------
							 */
							id: 'RdsOnVsId',
							mainHeading:
								'R[baseline-shift: sub; font-size: 11px;]dsON[/] = f (I[baseline-shift: sub; font-size: 11px;]DRAIN[/], V[baseline-shift: sub; font-size: 11px;]GS[/])',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.DC,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'I[baseline-shift: sub; font-size: 11px;]DRAIN[/]',
									unit: UNITS_SIGN.AMPER,
									columnNumber: this.DC_CHART_COLUMN_MAPPING.I_DRAIN,
									clampMaxRating: {
										mappingName: SINGLE_MOSFET.I_D_MAX
									}
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'R[baseline-shift: sub; font-size: 11px;]dsON[/]',
									unit: UNITS_SIGN.OHM,
									columnNumber: this.DC_CHART_COLUMN_MAPPING.R_DSON
								}
							],
							series: {
								/**
								 * Here graph parametrization is defined
								 */
								heading: 'V[baseline-shift: sub;font-size: 11px;]GS[/]',
								unit: UNITS_SIGN.VOLT,
								columnNumber: this.DC_CHART_COLUMN_MAPPING.V_GS
							}
						},
						{
							/**
							 * ---------------------------------------------------R_dsON vs V_GS ---------------------------------------------------
							 */
							id: 'RdsOnVsVgs',
							mainHeading:
								'R[baseline-shift: sub; font-size: 11px;]dsON[/] = f (V[baseline-shift: sub; font-size: 11px;]GS[/], V[baseline-shift: sub; font-size: 11px;]DS[/])',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.DC,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'V[baseline-shift: sub; font-size: 11px;]GS[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: this.DC_CHART_COLUMN_MAPPING.V_GS
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'R[baseline-shift: sub; font-size: 11px;]dsON[/]',
									unit: UNITS_SIGN.OHM,
									columnNumber: this.DC_CHART_COLUMN_MAPPING.R_DSON
								}
							],
							series: {
								/**
								 * Here graph parametrization is defined
								 */
								heading: 'V[baseline-shift: sub;font-size: 11px;]DS[/]',
								unit: UNITS_SIGN.VOLT,
								columnNumber: this.DC_CHART_COLUMN_MAPPING.V_DS
							}
						},
						{
							id: 'TjVsVds',
							mainHeading:
								'T[baseline-shift: sub; font-size: 11px;]J[/] = f (V[baseline-shift: sub;font-size: 11px;]DS[/],V[baseline-shift: sub;font-size: 11px;]GS[/])',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.DC,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'V[baseline-shift: sub;font-size: 11px;]DS[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: this.DC_CHART_COLUMN_MAPPING.V_DS
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'T[baseline-shift: sub; font-size: 11px;]J[/]',
									unit: UNITS_SIGN.CELSIUS,
									columnNumber: this.DC_CHART_COLUMN_MAPPING.T_J,
									clampMaxRating: {
										mappingName: SINGLE_MOSFET.T_J
									}
								}
							],
							series: {
								heading: 'V[baseline-shift: sub;font-size: 11px;]GS[/]',
								unit: UNITS_SIGN.VOLT,
								columnNumber: this.DC_CHART_COLUMN_MAPPING.V_GS
							}
						},
						{
							id: 'TjVsVgs',
							mainHeading:
								'T[baseline-shift: sub; font-size: 11px;]J[/] = f (V[baseline-shift: sub;font-size: 11px;]GS[/],V[baseline-shift: sub;font-size: 11px;]DS[/])',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.DC,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'V[baseline-shift: sub;font-size: 11px;]GS[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: this.DC_CHART_COLUMN_MAPPING.V_GS
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'T[baseline-shift: sub; font-size: 11px;]J[/]',
									unit: UNITS_SIGN.CELSIUS,
									columnNumber: this.DC_CHART_COLUMN_MAPPING.T_J,
									clampMaxRating: {
										mappingName: SINGLE_MOSFET.T_J
									}
								}
							],
							series: {
								heading: 'V[baseline-shift: sub;font-size: 11px;]DS[/]',
								unit: UNITS_SIGN.VOLT,
								columnNumber: this.DC_CHART_COLUMN_MAPPING.V_DS
							}
						}
					]
				},
				{
					heading: 'Thermal Properties Simulation',
					showRawData: false,
					inputHeading: 'Input parameters',
					note: 'The simulation is performed to plot Z<sub>TH</sub> curve from transistor thermal model as a response to 1 W (1 A) power into Tj node. The Tcase node is treated as an isothermal and therefore grounded (0\u00B0C). For a single shot pulse of 1 W (no duty cycle) the T<sub>J</sub> presents Z<sub>TH</sub>. Plot results are linearly decimated based on t<sub>sim step</sub> parameter.',
					showInputParams: false,

					inputParameters: [
						{
							heading: 'I<sub>GEN<sub>(min)</sub></sub>',
							unit: UNITS_SIGN.AMPER,
							netlistUnit: '',
							mappingName: 'IgenMin',
							minBoundary: 0,
							maxBoundary: 5,
							defaultValue: 0
						},
						{
							heading: 'I<sub>GEN<sub>(max)</sub></sub>',
							unit: UNITS_SIGN.AMPER,
							netlistUnit: '',
							mappingName: 'IgenMax',
							minBoundary: 0,
							maxBoundary: 10,
							defaultValue: 1
						},
						{
							heading: 't<sub>delay</sub>',
							unit: UNITS_SIGN.MICRO_SECOND,
							netlistUnit: 'u',
							mappingName: 'IgenTd',
							minBoundary: 0,
							maxBoundary: 25000,
							defaultValue: 0
						},
						{
							heading: 't<sub>rise</sub>',
							unit: UNITS_SIGN.NANO_SECOND,
							netlistUnit: 'n',
							mappingName: 'IgenTr',
							minBoundary: 0.1,
							maxBoundary: 1000000,
							defaultValue: 10
						},
						{
							heading: 't<sub>fall</sub>',
							unit: UNITS_SIGN.NANO_SECOND,
							netlistUnit: 'n',
							mappingName: 'IgenTf',
							minBoundary: 0.1,
							maxBoundary: 1000000,
							defaultValue: 10
						},
						{
							heading: 't<sub>pulse</sub>',
							unit: UNITS_SIGN.SECOND,
							netlistUnit: '',
							mappingName: 'IgenTpw',
							minBoundary: 0.000001,
							maxBoundary: 0.05,
							defaultValue: 0.01
						},
						{
							heading: 't<sub>periode</sub>',
							unit: UNITS_SIGN.SECOND,
							netlistUnit: '',
							mappingName: 'IgenPer',
							minBoundary: 0.000001,
							maxBoundary: 0.05,
							defaultValue: 0.01
						},
						{
							heading: 't<sub>sim step</sub>',
							unit: UNITS_SIGN.MICRO_SECOND,
							netlistUnit: 'u',
							mappingName: 'Tstep',
							minBoundary: 5,
							maxBoundary: 1000,
							defaultValue: 100
						},
						{
							heading: 't<sub>sim</sub>',
							unit: UNITS_SIGN.SECOND,
							netlistUnit: '',
							mappingName: 'tsim',
							minBoundary: 0.00001,
							maxBoundary: 0.03,
							defaultValue: 0.01
						},
						{
							heading: 't<sub>ambient<sub>',
							unit: UNITS_SIGN.CELSIUS,
							netlistUnit: '',
							mappingName: 'Tset',
							minBoundary: -40.0,
							maxBoundary: 175.0,
							defaultValue: 25,
							displayInput: true
						}
					],
					netlist: {
						heading: 'Netlist',
						netlistPath: this.netlistZthSim,
						displayNetlist: false
					},
					schematic: {
						heading: 'Transient thermal impedance response netlist schematic',
						schematicPath: this.SCHEMATICZthSim
					},
					charts: [
						{
							id: 'ZthVsTime',
							mainHeading: 'Z[baseline-shift: sub; font-size: 11px;]TH[/] = f (time)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: this.ZTH_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'Z[baseline-shift: sub; font-size: 11px;]TH[/]',
									unit: UNITS_SIGN.CELSIUSWATT,
									columnNumber: this.ZTH_CHART_COLUMN_MAPPING.T_J
								}
							],
							series: {
								heading: 't[baseline-shift: sub;font-size: 11px;]ambient[/]',
								unit: UNITS_SIGN.CELSIUS,
								columnNumber: this.ZTH_CHART_COLUMN_MAPPING.TEMP
							},
							isLogLog: true
						},
						{
							id: 'IpulseVsTime',
							mainHeading: 'I[baseline-shift: sub; font-size: 11px;]GEN[/] = f (time)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: this.ZTH_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'I[baseline-shift: sub; font-size: 11px;]GEN[/]',
									unit: UNITS_SIGN.AMPER,
									columnNumber: this.ZTH_CHART_COLUMN_MAPPING.IPULSE
								}
							],
							series: {
								heading: 't[baseline-shift: sub;font-size: 11px;]ambient[/]',
								unit: UNITS_SIGN.CELSIUS,
								columnNumber: this.ZTH_CHART_COLUMN_MAPPING.TEMP
							}
						}
					]
				},
				{
					heading: 'DC Temp Sweep Analysis',
					showRawData: false,
					inputHeading: 'Input parameters',
					showInputParams: false,

					netlist: {
						heading: 'Netlist',
						netlistPath: this.netlistTempSweep,
						displayNetlist: false
					},
					schematic: {
						heading: 'Netlist schematic',
						schematicPath: this.SCHEMATICTempSweep
					},
					charts: [
						{
							id: 'IdsVsTemp',
							mainHeading:
								'I[baseline-shift: sub; font-size: 11px;]DRAIN[/] = f (t[baseline-shift: sub;font-size: 11px;]ambient[/],V[baseline-shift: sub;font-size: 11px;]GS[/])',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.DC,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 't[baseline-shift: sub;font-size: 11px;]ambient[/]',
									unit: UNITS_SIGN.CELSIUS,
									columnNumber: this.TEMP_SWEEP_CHART_COLUMN_MAPPING.TEMP
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'I[baseline-shift: sub; font-size: 11px;]DRAIN[/]',
									unit: UNITS_SIGN.AMPER,
									columnNumber: this.TEMP_SWEEP_CHART_COLUMN_MAPPING.I_DRAIN,
									clampMaxRating: {
										mappingName: SINGLE_MOSFET.I_D_MAX
									}
								}
							],
							series: {
								heading: 'V[baseline-shift: sub;font-size: 11px;]GS[/]',
								unit: UNITS_SIGN.VOLT,
								columnNumber: this.TEMP_SWEEP_CHART_COLUMN_MAPPING.V_GS
							}
						},
						{
							id: 'IdsVsVgs',
							mainHeading:
								'I[baseline-shift: sub; font-size: 11px;]DRAIN[/] = f (V[baseline-shift: sub;font-size: 11px;]GS[/],t[baseline-shift: sub;font-size: 11px;]ambient[/])',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.DC,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'V[baseline-shift: sub;font-size: 11px;]GS[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: this.TEMP_SWEEP_CHART_COLUMN_MAPPING.V_GS
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'I[baseline-shift: sub; font-size: 11px;]DRAIN[/]',
									unit: UNITS_SIGN.AMPER,
									columnNumber: this.TEMP_SWEEP_CHART_COLUMN_MAPPING.I_DRAIN,
									clampMaxRating: {
										mappingName: SINGLE_MOSFET.I_D_MAX
									}
								}
							],
							series: {
								heading: 't[baseline-shift: sub;font-size: 11px;]ambient[/]',
								unit: UNITS_SIGN.CELSIUS,
								columnNumber: this.TEMP_SWEEP_CHART_COLUMN_MAPPING.TEMP
							}
						},
						{
							id: 'RdsONVsTemp',
							mainHeading:
								'R[baseline-shift: sub; font-size: 11px;]dsON[/] = f (t[baseline-shift: sub;font-size: 11px;]ambient[/],V[baseline-shift: sub;font-size: 11px;]GS[/])',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.DC,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 't[baseline-shift: sub;font-size: 11px;]ambient[/]',
									unit: UNITS_SIGN.CELSIUS,
									columnNumber: this.TEMP_SWEEP_CHART_COLUMN_MAPPING.TEMP,
									clampMaxRating: {
										mappingName: SINGLE_MOSFET.T_J
									}
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'R[baseline-shift: sub; font-size: 11px;]dsON[/]',
									unit: UNITS_SIGN.OHM,
									columnNumber: this.TEMP_SWEEP_CHART_COLUMN_MAPPING.R_DSON
								}
							],
							series: {
								heading: 'V[baseline-shift: sub;font-size: 11px;]GS[/]',
								unit: UNITS_SIGN.VOLT,
								columnNumber: this.TEMP_SWEEP_CHART_COLUMN_MAPPING.V_GS
							}
						},
						{
							id: 'RdsONVsVgs',
							mainHeading:
								'R[baseline-shift: sub; font-size: 11px;]dsON[/] = f (V[baseline-shift: sub;font-size: 11px;]GS[/],t[baseline-shift: sub;font-size: 11px;]ambient[/])',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.DC,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'V[baseline-shift: sub;font-size: 11px;]GS[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: this.TEMP_SWEEP_CHART_COLUMN_MAPPING.V_GS
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'R[baseline-shift: sub; font-size: 11px;]dsON[/]',
									unit: UNITS_SIGN.OHM,
									columnNumber: this.TEMP_SWEEP_CHART_COLUMN_MAPPING.R_DSON
								}
							],
							series: {
								heading: 't[baseline-shift: sub;font-size: 11px;]ambient[/]',
								unit: UNITS_SIGN.CELSIUS,
								columnNumber: this.TEMP_SWEEP_CHART_COLUMN_MAPPING.TEMP
							}
						},
						{
							id: 'TjVsVamb',
							mainHeading:
								'T[baseline-shift: sub; font-size: 11px;]J[/] = f (t[baseline-shift: sub;font-size: 11px;]ambient[/],V[baseline-shift: sub;font-size: 11px;]GS[/])',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.DC,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 't[baseline-shift: sub;font-size: 11px;]ambient[/]',
									unit: UNITS_SIGN.CELSIUS,
									columnNumber: this.TEMP_SWEEP_CHART_COLUMN_MAPPING.TEMP
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'T[baseline-shift: sub; font-size: 11px;]J[/]',
									unit: UNITS_SIGN.CELSIUS,
									columnNumber: this.TEMP_SWEEP_CHART_COLUMN_MAPPING.T_J,
									clampMaxRating: {
										mappingName: SINGLE_MOSFET.T_J
									}
								}
							],
							series: {
								heading: 'V[baseline-shift: sub;font-size: 11px;]GS[/]',
								unit: UNITS_SIGN.VOLT,
								columnNumber: this.TEMP_SWEEP_CHART_COLUMN_MAPPING.V_GS
							}
						},
						{
							id: 'TjVsVgsTamb',
							mainHeading:
								'T[baseline-shift: sub; font-size: 11px;]J[/] = f (V[baseline-shift: sub;font-size: 11px;]GS[/],t[baseline-shift: sub;font-size: 11px;]ambient[/])',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.DC,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'V[baseline-shift: sub;font-size: 11px;]GS[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: this.TEMP_SWEEP_CHART_COLUMN_MAPPING.V_GS
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'T[baseline-shift: sub; font-size: 11px;]J[/]',
									unit: UNITS_SIGN.CELSIUS,
									columnNumber: this.TEMP_SWEEP_CHART_COLUMN_MAPPING.T_J,
									clampMaxRating: {
										mappingName: SINGLE_MOSFET.T_J
									}
								}
							],
							series: {
								heading: 't[baseline-shift: sub;font-size: 11px;]ambient[/]',
								unit: UNITS_SIGN.CELSIUS,
								columnNumber: this.TEMP_SWEEP_CHART_COLUMN_MAPPING.TEMP
							}
						}
					]
				}
			]
		};

		return _.merge({}, defaultDefinition, customizations);
	}
}
